import { createContext } from "react";

export const NestedLevelContext = createContext(0);
